import { Box, Flex, Text } from '@mantine/core';
import { FC } from 'react';
import { PodcastCardProps } from './types';
import Image from 'next/image';
import { useRouter } from 'next/router';

export const PodcastCard: FC<PodcastCardProps> = ({ podcast }) => {
  const router = useRouter();

  const handleClickPodcast = () => {
    router.push(`/podcasts/${podcast?.slug}`);
  };

  return (
    <Flex
      gap={0}
      direction="column"
      onClick={handleClickPodcast}
      style={{ cursor: 'pointer' }}
    >
      <Box w="100%" h={{ base: 250, md: 200 }} pos="relative">
        <Image
          src={podcast?.header_image?.key ?? ''}
          alt={podcast?.title ?? ''}
          fill
          style={{ objectFit: 'cover' }}
          sizes="(max-width: 768px) 900px, (max-width: 1200px) 1366px, 700px"
        />
      </Box>
      <Text variant="body1" mah={90} lineClamp={4} component="p">
        {podcast?.description}
      </Text>
    </Flex>
  );
};
